/**
 * Short, display-friendly location name: the substring after the last "-",
 * trimmed (Shopmonkey names locations like "Poseidon Marine FL-Tampa " →
 * "Tampa"). Canonical home for this helper — ShopmonkeyLive.js and Dashboard.js
 * still carry legacy local copies that should migrate to this import.
 */
export function shortLocationName(name) {
  if (!name) return "—";
  const trimmed = name.trim();
  const dashIdx = trimmed.lastIndexOf("-");
  if (dashIdx !== -1) return trimmed.slice(dashIdx + 1).trim();
  return trimmed;
}
